module.exports = __webpack_public_path__ + "img/DTH.057da6d2.svg";